import {PanelDetailsComponent} from './panel-details.component';
import {PanelDetailsGroupComponent} from './panel-details.group.component';
import {PanelDetailsColumnComponent} from './panel-details.column.component';
import {PanelDetailsCellComponent} from './panel-details.cell.component';


export * from './panel-details.component';

export const PANEL_DETAILS_COMPONENTS = [
    PanelDetailsComponent,
    PanelDetailsGroupComponent,
    PanelDetailsColumnComponent,
    PanelDetailsCellComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/panel-details/index.ts